import type { ReactNode } from 'react';
import { useChatSocketBridge } from '@/hooks/useChatSocket';

/**
 * Mounts the global chat socket bridge once. State itself lives in the Zustand
 * store (`useChatStore`), so any component — a thread view today, the bell later
 * — reads the same store without prop drilling. Place inside <SocketProvider>.
 */
export function ChatProvider({ children }: { children: ReactNode }) {
  useChatSocketBridge();
  return <>{children}</>;
}
